module.exports = __webpack_public_path__ + "static/BeDetailed-d5b4b8d5ef9b7c8546ca448b5ce522d5.png";